import { useEffect, useState } from 'preact/hooks';

import { ERROR_EVENTS } from '@merkur/plugin-error';

import { useWidgetContext } from './useWidgetContext';
import { error } from '../lib/Log';

export function useLogin() {
	const { emit, props } = useWidgetContext();
	const [initialized, setInitialized] = useState(false);
	const [reported, setReported] = useState(false);
	const { id, loginCfg } = props.service;

	useEffect(() => {
		/**
		 * Don't initialize when loginCfg is empty, this allows users
		 * to customize ribbon-badge container to their needs.
		 */
		if (!loginCfg) {
			return;
		}

		const { login } = window;

		if (!login) {
			!reported &&
				emit?.(ERROR_EVENTS.ERROR, { error: new Error('Login is not loaded') });
			setReported(true);

			return error('Login object not found.');
		}

		login.cfg({
			serviceId: id,
			...loginCfg
		});

		setInitialized(true);
	}, [id, loginCfg, emit, reported]);

	return { initialized };
}
